import { createFileRoute, redirect } from '@tanstack/react-router';
import ManagerPortal from '../components/portals/ManagerPortal';

export const Route = createFileRoute('/manager/reservations/new')({
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/manager/orders/new', search });
  },
  component: ManagerLegacyNewReservationRoute,
});

function ManagerLegacyNewReservationRoute() {
  return (
    <ManagerPortal>
      <div />
    </ManagerPortal>
  );
}
